const camelToSnakeCase = str => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`)

export const toQueryParams = (object) => {
  const params = {}
  // Remove keys with undefined values
  Object.keys(object).forEach((key) => {
    if (object[key] !== undefined) {
      params[camelToSnakeCase(key)] = object[key]
    }
  })

  return new URLSearchParams(params).toString()
}
